import { Injectable } from '@angular/core';
import { HubService } from '@app/core/hubs/hub.service';
import { environment } from '../../../../environments/environment';
import { CompanyStatus } from '@app/shared/enums';

@Injectable({
  providedIn: 'root'
})
export class AccountHubService extends HubService<{
  companyId: string;
  companyStatus: CompanyStatus;
}> {
  constructor() {
    super();
  }

  override initHub(): void {
    super.initHub(`${environment.accountSignalrApi}/verificationHub`);
  }

  addDataListener(): void {
    this.hubConnection.on('OnMessageReceived', data => {
      this.streamReceivedData.emit(data);
    });
  }

  joinGroup(accountId: string): void {
    if (this.isHubConnected) {
      this.hubConnection.invoke('JoinGroup', accountId);
    }
  }
}
